import BaseForm from '../base';
export class ShutoffForm extends BaseForm {
    constructor(...args) {
        super(...args);
    }
}
